import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {
  Select,
  MenuItem,
} from '@material-ui/core'

import * as DeviceActionCreators from '../../actions/device'

class SensorSelectContainer extends React.Component {
  static propTypes = {
    deviceId: PropTypes.string.isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    devices: PropTypes.object.isRequired,
    deviceActions: PropTypes.object.isRequired,
  }

  static defaultProps = {
    value: null,
  }

  static mapStateToProps(state) {
    return {
      devices: state.devices,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      deviceActions: bindActionCreators(DeviceActionCreators, dispatch),
    }
  }

  componentDidMount() {
    const { deviceId, deviceActions } = this.props
    if (deviceId) {
      deviceActions.fetchDevice(deviceId)
    }
  }

  onChange = (e) => {
    this.props.onChange(e.target.value)
  }

  device() {
    return this.props.devices[this.props.deviceId] || {}
  }

  sensors() {
    return this.device().sensors || []
  }

  render() {
    const {
      deviceId, value, onChange, devices, deviceActions,
      ...props
    } = this.props

    return (
      <Select value={value} onChange={this.onChange} {...props}>
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {this.sensors().map((sensor) => (
          <MenuItem key={sensor.id} value={sensor.id}>
            {sensor.id}
          </MenuItem>
        ))}
      </Select>
    )
  }
}

export default connect(
  SensorSelectContainer.mapStateToProps,
  SensorSelectContainer.mapDispatchToProps,
)(SensorSelectContainer)
